<template>
<m-pageframe
    title="{organization-label}: Blocked (Spam) Numbers"
>
<v-container
    fluid
>

    <v-text-field
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
        autocomplete="off"
    />

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >
        <template v-slot:item.date="{ item }">
            {{$rc.pretty(item.time,'date')}}
        </template>

        <template v-slot:item.time="{ item }">
            {{$rc.pretty(item.time,'time')}}
        </template>

        <template v-slot:item.endpoint="{ item }">
            {{$rc.pretty(item.endpoint,'endpoint')}}
        </template>

        <template v-slot:item.action="{ item }">

            <v-menu 
                bottom 
                offset-y  
            >
            
            <template v-slot:activator="{ on }">
                    
                <v-icon 
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
                    
            </template>
            
            <v-list>
                <v-list-item
                    v-on:click="onClickUnblock(item)"
                >
                    <v-list-item-title>Unblock...</v-list-item-title>
                </v-list-item>
            
            </v-list>
            
            </v-menu> 

        </template>
    
    </v-data-table>

    <m-icon-bar
        v-on:add="onClickAdd"
    />

    <m-dialog-change-spam-state-endpoint
        ref="my-dialog"
        v-on:ok="doUpdate"
    />

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');
export default {

    data() {
        return {
            full_text: null,
            results: [],

            headers: [
                { text: 'Date', value: 'date'},
                { text: 'Time', value: 'time'},
                { text: 'Phone Number', value: 'endpoint'},
                { text: 'Name', value: 'endpoint_label'},
                { text: 'By', value: 'change_made_by_employee_label'},
                { text: 'Notes', value: 'notes'},
                { text: 'Action', value: 'action'},
            ],
        }
    },

   

    mounted () {
        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest(
                'LIST: /spam/endpoints',
            
                {
                    'organization_id': this.$route.params.organization_id,
                    'full_text': this.full_text,
                },
            
                (data) => {
                    this.results = data.results;

                    
                },
            
                () => {
                    this.$rc.alert('Error','Unable to list endpoints blocked as spam');
                },
            );
        },
    

        onClickUnblock(item) {
            this.$refs['my-dialog'].showDialog(false, item.endpoint);
        },

        onClickAdd() {
            this.$refs['my-dialog'].showDialog(true, null);
        },
    },
}
</script>

<style lang="scss" scoped>
</style>